const Activity = {
  path: '/activity',
  name: 'activity',
  component: () => import('@/views/activity/index.vue'),
  children: [
    {
      path: 'p150-paddle-gifts',
      name: 'activity-p150-paddle-gifts',
      component: () =>
        import(
          /* webpackChunkName: "p150-paddle-gifts" */ '@/views/activity/p150-paddle-gifts/index.vue'
        ),
      children: [
        {
          path: 'list',
          name: 'activity-p150-paddle-gifts-list',
          component: () =>
            import(
              /* webpackChunkName: "p150-paddle-gifts" */ '@/views/activity/p150-paddle-gifts/list.vue'
            ),
        },
        {
          path: 'sn',
          name: 'activity-p150-paddle-gifts-sn',
          component: () =>
            import(
              /* webpackChunkName: "p150-paddle-gifts" */ '@/views/activity/p150-paddle-gifts/input-sn.vue'
            ),
        },
        {
          path: 'protoc',
          name: 'activity-p150-paddle-gifts-protoc',
          component: () => import('@/views/serviceorder/protoc/Protoc.vue'),
        },
      ],
    },
    {
      path: 'old-bring-new',
      name: 'old-bring-new-index',
      component: () =>
        import(/* webpackChunkName: "old-bring-new" */ '@/views/activity/old-bring-new/index.vue'),
      children: [
        {
          path: 'old-user',
          name: 'activity-old-bring-new-old-user',
          component: () =>
            import(
              /* webpackChunkName: "old-bring-news" */ '@/views/activity/old-bring-new/old-user.vue'
            ),
        },
        {
          path: 'claim-page',
          name: 'activity-old-bring-new-claim-page',
          component: () =>
            import(
              /* webpackChunkName: "old-bring-news" */ '@/views/activity/old-bring-new/claim-page.vue'
            ),
        },
        {
          path: 'new-user',
          name: 'activity-old-bring-new-new-user',
          component: () =>
            import(
              /* webpackChunkName: "old-bring-news" */ '@/views/activity/old-bring-new/new-user.vue'
            ),
        },
        {
          path: 'middle-wrap',
          name: 'activity-old-bring-new-middle-wrap',
          component: () =>
            import(
              /* webpackChunkName: "old-bring-news" */ '@/views/activity/old-bring-new/middle-wrap.vue'
            ),
        },
        {
          path: 'rules-page',
          name: 'activity-old-bring-new-rules-page',
          component: () =>
            import(
              /* webpackChunkName: "old-bring-news" */ '@/views/activity/old-bring-new/rules-page.vue'
            ),
        },
      ],
    },
  ],
}
export default Activity
